export const agentRequests = {
  page: {
    filters: {
      accommodation: "Obiekt",
      type: "Typ",
    },
    subtitle: "O co poprosili Twoi goście przez agenta.",
    clearFilters: "Wyczyść filtry",
    loadMore: "Pokaż więcej",
    empty: "Nie ma jeszcze próśb.",
    emptyFiltered: "Brak próśb z tymi filtrami.",
    columns: {
      type: "Typ",
      guest: "Gość",
      asks: "Prośba",
      channel: "Kanał",
      status: "Status",
      when: "Kiedy",
      amount: "Kwota",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Zapłacono",
    awaiting: "Czeka na płatność",
    property: "Do zapłaty na miejscu",
    void: "Nie pobrano",
    quote: "Zaproponowano",
  },
  common: {
    title: "Zgłoszenia do recepcji AI",
  },
  widget: {
    iaBadge: "AI",
    subtitle: "O co Państwa goście poprosili za pośrednictwem agenta.",
    todayOn: "Widoczne tylko dzisiejsze",
    todayOff: "Pokaż tylko dzisiejsze zgłoszenia",
    today: "Dziś",
    entersToday: "Przyjazd dziś",
    entersTodayTitle: "Ta rezerwacja rozpoczyna się dziś",
    test: "test",
    approve: "Zatwierdź",
    otherTime: "Inna godzina",
    prioritize: "Priorytet",
    reject: "Odrzuć",
    dismiss: "Ukryj z panelu",
    loading: "Wczytywanie zgłoszeń…",
    empty: "Brak zgłoszeń.",
    emptySub: "Gdy gość poprosi o późny check-out, wcześniejszy check-in lub dodatkowe noce, zgłoszenie pojawi się tutaj.",
    viewAll: "Zobacz wszystkie zgłoszenia",
    entryTime: "Godzina check-in",
    cancel: "Anuluj",
    rejectIrreversible: "Tej operacji nie można cofnąć.",
    modal: {
      approveTitle: "Zatwierdzić zgłoszenie?",
      approveTimeTitle: "Zatwierdzić na inną godzinę?",
      tentativeTitle: "Nadać priorytet temu przyjazdowi?",
      rejectTitle: "Odrzucić zgłoszenie?",
      defaultTitle: "Potwierdzić?",
      approveText: "Wcześniejszy check-in zostanie zatwierdzony dla rezerwacji:",
      approveTimeText: "Check-in zostanie potwierdzony na ustawioną godzinę dla rezerwacji:",
      tentativeText: "Powiemy gościowi, że zrobicie wszystko, żeby było gotowe na tę godzinę, choć zależy to od wcześniejszego wymeldowania i sprzątania. Wyślemy do:",
      rejectText: "Wcześniejszy check-in zostanie odrzucony dla rezerwacji:",
      defaultText: "Potwierdzenie dla rezerwacji:",
      approveCta: "Tak, zatwierdź",
      approveTimeCta: "Potwierdź godzinę",
      tentativeCta: "Tak, powiadom",
      rejectCta: "Tak, odrzuć",
      defaultCta: "Potwierdź",
    },
  },
  drawer: {
    close: "Zamknij",
    allAccommodations: "Wszystkie obiekty",
    allTypes: "Wszystkie typy",
    today: "Dziś",
    yesterday: "Wczoraj",
    from: "Od",
    to: "Do",
    clear: "Wyczyść",
    writeWhatsapp: "Napisz na WhatsApp",
    noMessages: "Brak zapisanych wiadomości dla tego czatu.",
    pause: "Pauza",
    play: "Odtwórz",
    downloadMp3: "Pobierz MP3",
    viewReservation: "Zobacz rezerwację",
    loading: "Wczytywanie…",
    emptyFiltered: "Żadne zgłoszenie nie pasuje do tych filtrów.",
    end: "To wszystkie zgłoszenia.",
    features: {
      early: "Wcześniejszy check-in",
      late: "Późny check-out",
      extend: "Przedłużenie pobytu",
      invoice: "Faktura",
      handoff: "Wymagane działanie",
      callMessage: "Wiadomości z połączeń",
    },
    channels: {
      call: "Połączenie",
    },
  },
  box: {
    rooms: "{count} pokój | {count} pokoje | {count} pokoi",
    nights: "{count} noc | {count} noce | {count} nocy",
    guests: "{count} gość | {count} goście | {count} gości",
    earlyRequestedTitle: "Prośba o wcześniejszy check-in",
    arrivalRequestedTitle: "Prośba o godzinę przyjazdu",
    early: "Wcześniej",
    arrives: "Przyjazd",
  },
};
